import { createSelector } from '@reduxjs/toolkit';
import { getProfileState } from './getProfileState';

export const getFtsStatusForAgent = createSelector(
  getProfileState,
  (state) => state?.ftsStatusForAgent
);
